<template>
  <div class="nav-container">
    <div class="navs">
      <div class="logo">
        <router-link to="/index">
          <img src="../assets/log.png" alt="智砼兴华智能科技">
        </router-link>
      </div>
      
      <div class="nav-links">
        <router-link 
          v-for="(item, index) in nanData" 
          :key="index" 
          :to="item.url"
          class="nav-item"
          :class="{ 'has-dropdown': item.children && item.children.length }">
          {{ item.name }}
          <transition name="fade">
            <div class="dropdown-menu" v-if="item.children && item.children.length">
              <router-link 
                v-for="(child, childIndex) in item.children" 
                :key="childIndex" 
                :to="child.url"
                class="dropdown-item">
                {{ child.name }}
              </router-link>
            </div>
          </transition>
        </router-link>
      </div>
      
      <div class="nav-right">
        <div class="contact-info">
          <i class="el-icon-phone-outline"></i>
          <span>18574931510</span>
        </div>
      </div>
      
      <!-- 移动端菜单按钮 -->
      <div class="mobile-menu-toggle" @click="mobileMenuVisible = !mobileMenuVisible">
        <i :class="mobileMenuVisible ? 'el-icon-close' : 'el-icon-menu'"></i>
      </div>
    </div>
    
    <!-- 移动端菜单 -->
    <transition name="slide-down">
      <div class="mobile-menu" v-show="mobileMenuVisible">
        <router-link 
          v-for="(item, index) in nanData" 
          :key="index" 
          :to="item.url"
          class="mobile-nav-item"
          @click.native="mobileMenuVisible = false">
          {{ item.name }}
        </router-link>
        <div class="mobile-contact">
          <i class="el-icon-phone-outline"></i>
          <span>18574931510</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "navs",
  data() {
    return {
      nanData: [
        {name:'首页',url:'/index'},
        {name:'关于我们',url:'/intro'},
        {name:'产品展示',url:'/product'},
        {name:'系统方案',url:'/system'},
        {name:'软件定制',url:'/software'},
        {name:'新闻动态',url:'/company'},
        {name:'联系我们',url:'/aboutUS'},
      ],
      mobileMenuVisible: false
    }
  }
}
</script>

<style scoped>
/* 导航容器 */
.nav-container {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

/* 主导航栏 */
.navs {
  height: 70px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo样式 */
.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 35px;
  transition: transform 0.3s ease;
}

.logo:hover img {
  transform: scale(1.05);
}

/* 导航链接区域 */
.nav-links {
  display: flex;
  height: 100%;
}

.nav-item {
  position: relative;
  padding: 0 18px;
  height: 70px;
  line-height: 70px;
  color: #333;
  text-decoration: none;
  font-size: 15px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.nav-item:hover, 
.nav-item.router-link-exact-active {
  color: #006ab8;
  font-weight: 500;
}

.nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: #006ab8;
  transition: all 0.3s ease;
  transform: translateX(-50%);
}

.nav-item:hover::after,
.nav-item.router-link-exact-active::after {
  width: 70%;
}

/* 下拉菜单 */
.has-dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 70px;
  left: 0;
  min-width: 150px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.has-dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  padding: 10px 15px;
  color: #333;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 14px;
}

.dropdown-item:hover {
  background: #f5f7fa;
  color: #006ab8;
}

/* 右侧区域 */
.nav-right {
  display: flex;
  align-items: center;
}

.contact-info {
  display: flex;
  align-items: center;
  color: #333;
  font-size: 15px;
  background: #f5f7fa;
  padding: 8px 15px;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.contact-info:hover {
  background: #e6f7ff;
  color: #006ab8;
}

.contact-info i {
  color: #006ab8;
  margin-right: 8px;
  font-size: 16px;
}

/* 移动端菜单按钮 */
.mobile-menu-toggle {
  display: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f5f7fa;
  display: none;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover {
  background: #e6f7ff;
  color: #006ab8;
}

/* 移动端菜单 */
.mobile-menu {
  display: none;
  flex-direction: column;
  background: white;
  padding: 10px 0;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.mobile-nav-item {
  padding: 15px 20px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.mobile-nav-item:last-child {
  border-bottom: none;
}

.mobile-nav-item:hover,
.mobile-nav-item.router-link-exact-active {
  color: #006ab8;
  background: #f5f7fa;
}

.mobile-contact {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  color: #333;
  border-top: 1px solid #f0f0f0;
  margin-top: 10px;
}

.mobile-contact i {
  color: #006ab8;
  margin-right: 10px;
  font-size: 18px;
}

/* 动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .navs {
    width: 95%;
  }
}

@media (max-width: 992px) {
  .nav-links {
    display: none;
  }
  
  .nav-right {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: flex;
  }
  
  .mobile-menu {
    display: flex;
  }
  
  .logo {
    margin-right: 0;
  }
}
</style>